import { billPresentmentAPI, billPresentmentActions } from 'app-components/flux/bill-presentment';
import { scheduledTransactionsActions, scheduledTransactionsTypes } from 'app-components/flux/scheduled-transactions';
import { tracker } from 'app-components/utils/core';

export function HandleDisconnectOption(dispatch, model, location, removeUndo) {
  dispatch(billPresentmentActions.disconnect({ model, hideUndo: removeUndo }));
  tracker.track(tracker.events.disconnectBiller, { initiator: location });
}

export function HandleEndOption(dispatch, model, location, removeUndo) {
  if (model?.presentmentAccountId) {
    billPresentmentAPI.delete(model.presentmentAccountId);
    tracker.track(tracker.events.disconnectBiller, { initiator: location });
  }
  dispatch(
    scheduledTransactionsActions.updateScheduledTransaction(
      scheduledTransactionsTypes.mkScheduledTransactionPatch({
        id: model.id,
        isCompleted: true,
        isUserVerified: true,
        presentmentAccountId: '',
      }),
      !removeUndo && { undo: { userMessage: 'Series ended' } },
    ),
  );
}
